import React from 'react';

const ArrowRightRotateIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" stroke="#C3C5CA" fill="none" {...rest}>
      <path d="M14 13.3974V1.5M14 1.5L1 14.5M14 1.5H2.10256" strokeWidth="2.2"/>
    </svg>
  );
};

export default ArrowRightRotateIcon;